import { useState } from 'react';
import { FaFolderOpen, FaPowerOff } from 'react-icons/fa';
import { ref, listAll, getDownloadURL } from 'firebase/storage';
import { storage } from '../../firebase';
import FileSelector from './FileSelector';
import { useConfig } from '../../useConfig';

function Filebar({ loadedPdf, setLoadedPdf }) {
    const storageRef = ref(storage);
    const [menuOpt, setMenuOpt] = useState(null);
    const [fileList, setFileList] = useState([]);
    const config = useConfig();

    const closeWind = () => {
        setMenuOpt(null);
    };

    const listFiles = async (val) => {
        if (val === menuOpt) {
            setMenuOpt(null);
            return;
        }
        const res = await listAll(storageRef);
        setFileList(res.items);
        setMenuOpt(val);
    };

    const openIframe = (val) => {
        if (val === menuOpt) {
            setMenuOpt(null);
            return;
        }
        setMenuOpt(val);
    };

    const handleResetApp = () => {
        // Reset the loaded PDF
        setLoadedPdf(null);
        // Additional reset logic can go here, if needed
        console.log("Application has been reset!");
    };

    function openOneDrive() {
        window.open('https://onedrive.live.com/about/en-gb/signin/', '_blank');
    };

    return (
        <>
            <ul>
            <li>
                    <button className="menu-section" onClick={() => listFiles(2)} style={{ position: 'relative' }}>
                        <FaFolderOpen />
                        <span style={{ position: 'absolute', opacity: 0.0, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>OPEN PDF</span>
                    </button>
                </li>
                <li>
                    <button className="menu-section" onClick={handleResetApp}>
                        <FaPowerOff />
                        <span style={{ position: 'absolute', opacity: 0, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>RESET</span>
                    </button>
                </li>
                {/*                 <li>
                    <button className="menu-section" onClick={() => window.open(config.serviceLinks.RA3651, '_blank')}>
                        <FaPhone />
                        <span style={{ position: 'absolute', opacity: 0, top: '65%', left: '50%', transform: 'translate(-50%, -50%)' }}>CALL SUPPORT</span>
                    </button>
                </li> */}



            </ul>
            {menuOpt === 2 ? (
                <FileSelector
                    fileList={fileList}
                    setLoadedPdf={setLoadedPdf}
                    closeWind={closeWind}
                />
            ) : null}
        </>
    );
}

export default Filebar;
